// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Am0j","textarea":"styles_textarea__3clJQ"};